// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"styles_sectionHeading__1Vpoz","subSectionHeading":"styles_subSectionHeading__3Wjrz"};